import { i18nMark } from 'lingui-react';

const messages = {
  createNewServiceRequest: i18nMark('Create New Service Request'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/TopNav/AddNew/messages.js